import { render, staticRenderFns } from "./DefaultRevisionSheet.vue?vue&type=template&id=c71246b6&"
import script from "./DefaultRevisionSheet.vue?vue&type=script&lang=ts&"
export * from "./DefaultRevisionSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports